<template>
  <div
    class="logo-upload-fields"
    :style="presentUploadFieldStyle"
    @click="handleUploadFieldClick"
  >
    <i
      v-show="logoImageSrc === null"
      class="el-icon-plus plus-icon"
    />
    <input
      ref="inputFileEl"
      type="file"
      accept="image/*"
      @change="onFileUploadChange"
    >
  </div>
</template>

<script>
import { fiflboxApi } from '@/utils/api';

export default {
  name: 'CenterLogoUploadField',
  props: {
    originLogoImageSrc: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      logoImageSrc: null,
    };
  },
  computed: {
    presentUploadFieldStyle() {
      if (this.logoImageSrc === null) {
        return {};
      }

      return {
        backgroundColor: 'white',
        backgroundImage: `url(${this.logoImageSrc})`,
      };
    },
  },
  watch: {
    originLogoImageSrc: {
      immediate: true,
      handler(imageSrc) {
        this.logoImageSrc = imageSrc;
      },
    },
  },
  methods: {
    handleUploadFieldClick() {
      this.$refs['inputFileEl'].click();
    },
    async onFileUploadChange($event) {
      if ($event.target.files.length === 0) {
        return;
      }

      const imageFile = $event.target.files[0];

      if (imageFile.size > 3 * 1024 * 1024) {
        return this.$alert(
          '로고 이미지의 크기가 3MB를 초과합니다.',
          '로고 이미지 업로드 오류',
        );
      }

      const imageSrc = await this.uploadImage(imageFile);
      this.logoImageSrc = imageSrc;
      this.$emit('change', this.logoImageSrc);
    },
    async uploadImage(imageFile) {
      const formData = new FormData();
      formData.append('image', imageFile);
      formData.append('usage', 1);

      const { data } = await fiflboxApi.v2.postAccountImages(formData, {
        headers: { 
          'Content-Type': 'multipart/form-data',
        },
      });

      return data.image;
    },
  },
};
</script>

<style lang="scss">
.logo-upload-fields {
	width: 100px;
	height: 100px;
	border-radius: 10px;
	background-color: #f2f2f2;
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
	border: dotted 1px #b9b9b9;
	cursor: pointer;

	.plus-icon {
		font-size: 14px;
		color: #8c939d;
		width: 100px;
		height: 100px;
		line-height: 100px;
		text-align: center;
		font-weight: bold;
	}

	input[type="file"] {
		display: none;
	}

	&:hover {
		border: dotted 1px #4a4a4a;
	}
}
</style>
